import React from 'react';
import {Poi} from '../../react-app-env';

export const HoveringPoisContext = React.createContext<Poi[]>(null as any);

export function useHoveringPois() {
  return React.useContext(HoveringPoisContext);
}
